export const parseError = (err, defaultErrorText = 'error', overrideErrorText = '') => {
    let errorText;
    if(overrideErrorText)
        errorText = overrideErrorText;
    else if (err && err.statusText) {
        errorText = err.statusText;
    } else if (err.error && err.error.message) {
        errorText = err.error.message;
    } else if (err && err.status) {
        errorText = `status ${err.status}:  ${defaultErrorText}`;
    } else {
        errorText = defaultErrorText;
    }
    return errorText;
};
